import { createContext, useContext, type ReactNode } from "react";
import { fmtDate } from "@/ui";

const ArchiveContext = createContext(false);
export const useArchived = () => useContext(ArchiveContext);

/** The owning record read supplies this state; this boundary never fetches another record. */
export function ArchivedRecord({ record, children }: {
  record: { state_archive?: string; archived_at?: string | null } | undefined;
  children: ReactNode;
}) {
  const archived = record?.state_archive === "archived";
  return <ArchiveContext.Provider value={archived}>
    {archived && <p className="archive-banner" role="status">Archived {fmtDate(record.archived_at)} · read-only</p>}
    {children}
  </ArchiveContext.Provider>;
}
